import React, { useState } from 'react';
import './ConsentModal.css';

const ConsentModal = ({ isOpen, onConsent }) => {
    const [isAgeChecked, setIsAgeChecked] = useState(false);
    const [isTermsChecked, setIsTermsChecked] = useState(false);

    if (!isOpen) return null;

    const handleConsent = () => {
        if (isAgeChecked && isTermsChecked) {
            onConsent();
        }
    };

    return (
        <div className="consent-modal-overlay">
            <div className="consent-modal-content">
                <h2>利用規約の確認</h2>
                <p>当サービスはOpenAIのAPIを使用しています。ご利用にあたり、以下の事項への同意が必要です。</p>

                <ul style={{ textAlign: 'left', marginBottom: '20px', fontSize: '14px', color: '#555', paddingLeft: '20px' }}>
                    <li>13歳未満の方は本サービスをご利用いただけません。</li>
                    <li>13歳以上18歳未満の方は、保護者の同意が必要です。</li>
                    <li>個人情報は入力しないでください。</li>
                    <li>AIの生成内容は必ずしも正確であるとは限りません。重要な情報は別途確認してください。</li>
                </ul>

                <div className="consent-checkbox-group">
                    <label className="consent-checkbox-label">
                        <input
                            type="checkbox"
                            checked={isAgeChecked}
                            onChange={(e) => setIsAgeChecked(e.target.checked)}
                        />
                        <span>上記内容を確認し、年齢要件を満たしていることに同意します。</span>
                    </label>
                </div>

                <div className="consent-checkbox-group">
                    <label className="consent-checkbox-label">
                        <input
                            type="checkbox"
                            checked={isTermsChecked}
                            onChange={(e) => setIsTermsChecked(e.target.checked)}
                        />
                        <span>
                            <a href="/terms" target="_blank" rel="noopener noreferrer">利用規約</a>
                            、
                            <a href="/privacy" target="_blank" rel="noopener noreferrer">プライバシーポリシー</a>
                            および
                            <a href="https://openai.com/ja-JP/policies/row-terms-of-use/" target="_blank" rel="noopener noreferrer">OpenAIの利用規約</a>
                            を確認し、同意します。
                        </span>
                    </label>
                </div>

                <button
                    className="consent-button"
                    onClick={handleConsent}
                    disabled={!isAgeChecked || !isTermsChecked}
                >
                    同意して利用を開始する
                </button>
            </div>
        </div>
    );
};

export default ConsentModal;
